import React from "react"
import services1 from "../images/services1.png"
import services2 from "../images/services2.png"

export default function ServicesContent() {
  return (
    <div className="relative py-16 bg-white overflow-hidden">
      <div className="hidden lg:block lg:absolute lg:inset-y-0 lg:h-full lg:w-full">
        <div
          className="relative h-full text-lg max-w-prose mx-auto"
          aria-hidden="true"
        >
          <svg
            className="absolute top-12 left-full transform translate-x-32"
            width={404}
            height={384}
            fill="none"
            viewBox="0 0 404 384"
          >
            <defs>
              <pattern
                id="74b3fd99-0a6f-4271-bef2-e80eeafdf357"
                x={0}
                y={0}
                width={20}
                height={20}
                patternUnits="userSpaceOnUse"
              >
                <rect
                  x={0}
                  y={0}
                  width={4}
                  height={4}
                  className="text-gray-200"
                  fill="currentColor"
                />
              </pattern>
            </defs>
            <rect
              width={404}
              height={384}
              fill="url(#74b3fd99-0a6f-4271-bef2-e80eeafdf357)"
            />
          </svg>
          <svg
            className="absolute top-1/2 right-full transform -translate-y-1/2 -translate-x-32"
            width={404}
            height={384}
            fill="none"
            viewBox="0 0 404 384"
          >
            <defs>
              <pattern
                id="f210dbf6-a58d-4871-961e-36d5016a0f49"
                x={0}
                y={0}
                width={20}
                height={20}
                patternUnits="userSpaceOnUse"
              >
                <rect
                  x={0}
                  y={0}
                  width={4}
                  height={4}
                  className="text-gray-200"
                  fill="currentColor"
                />
              </pattern>
            </defs>
            <rect
              width={404}
              height={384}
              fill="url(#f210dbf6-a58d-4871-961e-36d5016a0f49)"
            />
          </svg>
          <svg
            className="absolute bottom-12 left-full transform translate-x-32"
            width={404}
            height={384}
            fill="none"
            viewBox="0 0 404 384"
          >
            <defs>
              <pattern
                id="d3eb07ae-5182-43e6-857d-35c643af9034"
                x={0}
                y={0}
                width={20}
                height={20}
                patternUnits="userSpaceOnUse"
              >
                <rect
                  x={0}
                  y={0}
                  width={4}
                  height={4}
                  className="text-gray-200"
                  fill="currentColor"
                />
              </pattern>
            </defs>
            <rect
              width={404}
              height={384}
              fill="url(#d3eb07ae-5182-43e6-857d-35c643af9034)"
            />
          </svg>
        </div>
      </div>
      <div className="relative px-4 sm:px-6 lg:px-8">
        <div className="text-lg max-w-prose mx-auto prose">
          <h1 id="our-washed-services">OUR WASHED SERVICES</h1>
          <div className="relative bg-gray-200 rounded-xl shadow-2xl overflow-y-clip">
            <img
              src={services2}
              alt=""
              className="w-full h-full object-cover"
            />
          </div>
          <p>
            When it comes to WASH Education, Masy Consultants offer expertise in
            assisting a wide range of organisations. We work with elementary,
            junior high and high schools, universities, government agencies and
            their affiliates, and corporations seeking to meaningfully give back
            to communities through targeted and sustainable Corporate Social
            Responsibility (CSR) initiatives.
          </p>
          <h2 id="our-services-include-">Our services include:</h2>
          <ol>
            <li>
              <p>
                <strong>Educator Programs: </strong>
                We empower Educators to develop a robust understanding of the
                WASHEd Learning Curriculum and feel confident in their skills to
                guide the learning of their students and school communities.
              </p>
            </li>
            <li>
              <p>
                <strong>Community-based Training: </strong>
                We facilitate bespoke Community-based Training for local
                communities to enhance their understanding of WASH in line with
                the WASHEd Learning Curriculum.
              </p>
            </li>
            <li>
              <p>
                <strong>
                  Corporate Social Responsibility (CSR) Programs:{" "}
                </strong>
                We work with you in designing and/or delivering CSR initiatives
                in line with your company&#39;s objectives to maximise your
                social impact. This generally includes:
              </p>
              <ul>
                <li>
                  <p>
                    Empowering staff with a deepened understanding of WASH
                    through engaging and fun workshop activities
                  </p>
                </li>
                <li>
                  <p>
                    Mobilising funds to finance the delivery of WASHEd to needy
                    schools and communities
                  </p>
                </li>
                <li>
                  <p>
                    Overseeing field investigations and the construction of WASH
                    facilities in collaboration with barangay leaders and local
                    trades to promote self-sufficiency
                  </p>
                </li>
              </ul>
            </li>
            <li>
              <p>
                <strong>Certified Training for WASHEd Facilitators: </strong>
                We will be developing training programs for individuals and/or
                groups interested in becoming Certified WASHEd Facilitators.
                This program will be offered from mid-2022.
              </p>
            </li>
          </ol>
          <div className="flex justify-center">
            <a
              href="https://www.google.com/url?q=https://docs.google.com/forms/d/e/1FAIpQLScUpuMuYd4tVZD4wD8NKpiTERRKpJPTr6BN8FpO6HvObw-Diw/viewform&sa=D&source=docs&ust=1651064407068977&usg=AOvVaw0SZS6o-NA-Nr36jtS-0qpc"
              target="_blank"
              className="no-underline inline-flex items-center px-6 py-3 border border-transparent font-medium rounded-md shadow-sm text-white bg-[#004fff] hover:bg-blue-700"
            >
              Book a Consultation
            </a>
          </div>
          <div className="relative bg-gray-200 rounded-xl shadow-2xl overflow-y-clip">
            <img
              src={services1}
              alt=""
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </div>
    </div>
  )
}
